import styled from 'styled-components';
import {device} from 'styled/device';
import {CustomIcon} from '@guestapp/ui';

export const Wrapper = styled.div`
  position: relative;
  padding: 10px 8px 10px 16px;
  gap: 16px;
  width: 100%;
  background: ${({theme}) =>
    theme.hasTemplate ? theme.colors.branding.boxesModals : theme.colors.$p6};
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.07);
  border-radius: 6px;
  margin-bottom: 32px;
  max-width: 380px;
  cursor: pointer;
  @media (min-width: ${device.tablet}) {
    max-width: 420px;
  }
`;

export const AutoFillText = styled.div``;

export const AutoFillTitle = styled.div`
  display: flex;
  & span {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.15px;
    color: ${({theme}) => theme.colors.branding.primary};
    max-width: 270px;
    @media (min-width: ${device.tablet}) {
      max-width: 320px;
    }
  }
`;

export const AutoFillSubTitle = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  color: ${props =>
    props.theme.hasTemplate
      ? props.theme.colors.branding.fontPrimary
      : props.theme.colors.$p10};
`;

export const IconWrapper = styled.div`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
`;

export const StyledIcon = styled(CustomIcon)`
  path {
    stroke: ${({theme}) => theme.colors.branding.primary};
    fill: ${({theme}) => theme.colors.branding.primary};
  }
`;

export const StyledArrowIcon = styled(CustomIcon)`
  path {
    stroke: ${({theme}) => theme.colors.branding.primary};
  }
`;
